import React, { useEffect, useState, useMemo } from "react";
import { useMediaQuery } from "@mui/material";
import ReOrderParagraphs from "../../Reading/ReOrderParagraphs";
import FillBlanksCard from "../../Reading/FillBlanksCard";
import ReadingAndWritingBlanks from "../../Reading/ReadingAndWritingBlanks";
import { PurpleBtn } from "../../Common/Style";
import { useNavigate } from "react-router-dom";
import { Snackbar } from "@mui/joy";
import {
  FillBlanksCardData,
  ReadingAndWritingBlanksData,
} from "../../Reading/data";
import SaveExitBtn from "../SaveExitBtn";
import { useReadingQuestion } from "../hooks/useReadingQuestion";
import { useReadingSubmission } from "../hooks/useReadingSubmission";
import { useReadingValidation } from "../hooks/useReadingValidation";
import { formatReadingText } from "../utils/readingHelpers";
import { READING_GUIDELINES, END_MODAL_SENTENCES } from "../constants/readingConstants";
import TransitionContainer from "../Common/TransitionContainer";


export default function ReadingFull({
  ExamId,
  quest,
  setStep,
  step,
  totalQuestions,
  MockTestAttemptID,
  commulative,
  setCommulative,
  questionsTime,
  startStopwatch,
  stopStopwatch,
  resetQuestionTimer,
  submitTriggerRef,
  questions,
  endTestAndTimeout,
  getCachedQuestionData,
}) {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [SelectedAnswers, setSelectedAnswers] = useState([]);
  const [userOrder, setUserOrder] = useState([]);
  const [textAnswers, setTextAnswers] = useState([""]);
  const [endModalOpen, setEndModalOpen] = useState(false);
  const isLaptopTwo = useMediaQuery("(max-width:1000px)");
  const [currentSentence, setCurrentSentence] = useState("");
  const navigate = useNavigate();

  const cachedQuestionData = getCachedQuestionData ? getCachedQuestionData(quest) : null;
  const { questData, loading, modifiedTextValue } = useReadingQuestion(quest, startStopwatch, cachedQuestionData);
  const isInitialLoading = loading && !questData;
  const isFetchingNext = loading && !!questData;
  const guidelineText = useMemo(() => READING_GUIDELINES[quest?.SubCategory], [quest?.SubCategory]);

  const { disabled: isNextButtonDisabled } = useReadingValidation(quest, questData, selectedOptions, SelectedAnswers, textAnswers, userOrder);

  const { networkError, setNetworkError, handleNext } = useReadingSubmission({
    quest,
    questData,
    selectedOptions,
    SelectedAnswers,
    textAnswers,
    userOrder,
    questionsTime,
    MockTestAttemptID,
    ExamId,
    step,
    totalQuestions,
    commulative,
    setStep,
    setSelectedOptions,
    setSelectedAnswers,
    setTextAnswers,
    setUserOrder,
    setCommulative,
    stopStopwatch,
    resetQuestionTimer,
    submitTriggerRef,
    questions,
    setEndModalOpen,
    endTestAndTimeout,
    navigateOnErrorPath: "/Mocktest",
    navigateOnEndPath: "/MockTest"
  });

  const handleChangeRadio = (e) => {
    setSelectedOptions(e.target.value);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      setSelectedOptions((prev) => [...prev, value]);
    } else {
      setSelectedOptions((prev) => prev.filter((item) => item !== value));
    }
  };

  useEffect(() => {
    const displayRandomText = () => {
      const randomIndex = Math.floor(Math.random() * END_MODAL_SENTENCES.length);
      setCurrentSentence(END_MODAL_SENTENCES[randomIndex]);
    };
    const intervalId = setInterval(displayRandomText, 2000);
    displayRandomText();
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={{}}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={4000}
        open={networkError}
        variant={"outlined"}
        color={"danger"}
        onClose={() => {
          setNetworkError(false);
        }}
      >
        Network Error
      </Snackbar>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: isLaptopTwo ? "1rem 5% 2rem" : "3rem 5% 2rem",
        }}
      >
        <div
          style={{
            backgroundColor: "white",
            // height: "400px",
            width: "100%",
            borderRadius: "24px",
            position: "relative",
            overflow: "clip",
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "#e2e2ea",
              height: "13px",
              position: "absolute",
            }}
          ></div>
          <div
            style={{
              width: `${(step / totalQuestions) * 100}%`,
              backgroundColor: "#996cfe",
              height: "13px",
              position: "absolute",
            }}
          ></div>
          <TransitionContainer isInitialLoading={isInitialLoading} isFetchingNext={isFetchingNext}>
            <div style={{ height: "100%" }}>
              <h1
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  lineHeight: "32px",
                  userSelect: "none",
                }}
                onCopy={(e) => e.preventDefault()}
              >
                {guidelineText}
              </h1>
              {quest.SubCategory === "Re-order Paragraphs" ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    userSelect: "none",
                  }}
                  onCopy={(e) => e.preventDefault()}
                >
                  <ReOrderParagraphs
                    // key={`re-order-paragraph-${quest.num}`}
                    OptionNames={questData?.OptionNames}
                    setUserOrder={setUserOrder}
                  />
                </div>
              ) : quest.SubCategory === "Reading: Fill in the Blanks" ? (
                <div
                  style={{
                    userSelect: "none",
                  }}
                  onCopy={(e) => e.preventDefault()}
                >
                  <FillBlanksCard
                    id={FillBlanksCardData[0].id}
                    textValue={modifiedTextValue}
                    fillingWords={questData?.OptionNames}
                    setSelectedAnswers={setSelectedAnswers}
                  />
                </div>
              ) : quest.SubCategory ===
                "Reading & Writing: Fill in the Blanks" ? (
                <div
                  style={{
                    userSelect: "none",
                  }}
                  onCopy={(e) => e.preventDefault()}
                >
                  <ReadingAndWritingBlanks
                    id={ReadingAndWritingBlanksData[0].id}
                    textValue={questData?.QuestionStatement}
                    dropDownOptions={questData?.OptionNames}
                    setSelectedAnswers={setTextAnswers}
                  />
                </div>
              ) : null}

              {(quest.SubCategory === "Multiple Choice, Multiple Answers" ||
                quest.SubCategory === "Multiple Choice, Single Answer") && (
                <div
                  style={{
                    fontFamily: "Noto Sans",
                    fontSize: "18px",
                    fontWeight: 500,
                    userSelect: "none",
                  }}
                  onCopy={(e) => e.preventDefault()}
                >
                  {questData?.QuestionStatement}
                  {questData?.OptionText && (
                    <div style={{ marginTop: "18px", fontWeight: 600 }}>
                      {questData.OptionText}
                    </div>
                  )}
                  <div>
                    {questData?.OptionNames?.map((option, index) => {
                      const label = option; // Extracts 'a', 'b', 'c', etc.
                      return (
                        <div
                          key={index}
                          style={{
                            paddingTop: "15px",
                            fontSize: "17px",
                            fontWeight: 400,
                          }}
                        >
                          <label>
                            {quest.SubCategory ===
                            "Multiple Choice, Single Answer" ? (
                              <input
                                type="radio"
                                name="options"
                                value={label}
                                checked={selectedOptions === label}
                                onChange={handleChangeRadio}
                              />
                            ) : (
                              <input
                                type="checkbox"
                                value={label}
                                checked={selectedOptions.includes(label)}
                                onChange={handleChange}
                              />
                            )}
                            {option}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "25px",
                }}
              >
                <SaveExitBtn />
                
                {isNextButtonDisabled && step === totalQuestions ? (
                  <PurpleBtn disabled={true}>
                    Loading...
                  </PurpleBtn>
                ) : (
                  <PurpleBtn
                    onClick={() => {
                      if (!isNextButtonDisabled) {
                        handleNext();
                      }
                    }}
                    disabled={isNextButtonDisabled}
                  >
                    Next
                  </PurpleBtn>
                )}
              </div>
            </div>
          </TransitionContainer>
        </div>
      </div>
    </div>
  );
}
